import { z } from 'zod'

export const loopModeSchema = z.enum(['hard', 'ping-pong', 'crossfade', 'hold-snap'])
export const mediaStatusSchema = z.enum(['local', 'uploading', 'uploaded', 'queued', 'rendering', 'processing', 'ready', 'failed', 'blocked'])

export const renderSegmentSchema = z.object({
  id: z.string().min(1),
  mediaAssetId: z.string().optional(),
  mediaUrl: z.string().min(1),
  inMs: z.number().finite().min(0),
  outMs: z.number().finite().positive(),
  playbackRate: z.number().finite().min(0.25).max(4),
  volume: z.number().finite().min(0).max(1),
  filter: z.enum(['none', 'mono', 'acid', 'soft']),
  order: z.number().int().min(0),
  sourceDurationMs: z.number().positive().optional()
}).refine((segment) => segment.outMs > segment.inMs, 'Segment out point must follow its in point.')

export const timedTextSchema = z.object({
  id: z.string().min(1),
  text: z.string().min(1).max(60),
  startMs: z.number().min(0),
  endMs: z.number().positive(),
  position: z.enum(['top', 'center', 'bottom'])
}).refine((cue) => cue.endMs > cue.startMs, 'Text cue must have a positive duration.')

export const renderRecipeSchema = z.object({
  version: z.literal(1),
  segments: z.array(renderSegmentSchema).min(1).max(12),
  loopMode: loopModeSchema,
  crossfadeMs: z.number().int().min(80).max(180),
  holdMs: z.number().int().min(120).max(400),
  textCues: z.array(timedTextSchema).max(12),
  beatMarkers: z.array(z.number().min(0)).max(24),
  originalAudio: z.boolean(),
  output: z.object({
    width: z.number().int().positive().max(1080),
    height: z.number().int().positive().max(1920),
    fps: z.number().int().min(24).max(60),
    videoCodec: z.literal('h264'),
    audioCodec: z.literal('aac')
  })
})

export const uploadSessionSchema = z.object({
  id: z.string().min(1),
  assetId: z.string().min(1),
  path: z.string().min(1),
  uploadUrl: z.string().url(),
  token: z.string().optional(),
  expiresAt: z.string().datetime(),
  maxBytes: z.number().int().positive()
})

export const feedCursorSchema = z.object({ createdAt: z.string().datetime(), loopId: z.string().min(1) })
